<template>
    <div class="w-[4px] bg-darkblue absolute z-0" :class="lineHeightPositionClass"></div>
</template>

<script>
export default {
    name: "BackLine",
    props: {
        position: {
            type: Number
        },
        total: {
            type: Number
        }
    },
    computed: {
        lineHeightPositionClass() {

            if (this.position === 0) {
                return 'h-1/2 top-1/2';

            }
            if (this.position === this.total - 1) {
                return 'h-1/2 top-0';
            }
            
            return 'h-full top-0';
        }
    }
}
</script>

<style scoped>

</style>